import { createAction, props } from '@ngrx/store';
import { StringDto } from 'src/app/models/basic/string-dto';

export const uploadImage = createAction(
  '[image] upload',
  props<{ base64: StringDto }>()
);

export const uploadImageSuccess = createAction(
  '[image] upload success',
  props<{uri: string}>()
);

export const uploadImageReset = createAction(
  '[image] upload reset'
);

export const uploadImageFailed = createAction(
  '[image] upload failed'
);
